export default {
    methods: {
        getType(path, obj, fallback){
            return _.has(path, obj) ? 'is-danger' : fallback
        },

        getError(path, obj){
            if(_.has(path, obj)){
                return path[obj][0]
            } else return ''
        }
    }
}